import { IonIcon } from '@ionic/react';
import { checkmarkCircleOutline, closeCircleOutline } from 'ionicons/icons';
import Button from '../../../../Button/Button';
import { useTranslate } from '../../../../../hooks/context/useTranslate';
import { SelectedFilter } from '../../../../../types/types';

interface FilterHeaderProps {
  dataset: any;
  selectedFilters: SelectedFilter[];
  caption: string;
  onSubmitFilters: () => void;
  onResetFilters: () => void;
}

const FilterHeader = ({
  dataset,
  selectedFilters,
  caption,
  onSubmitFilters,
  onResetFilters,
}: FilterHeaderProps) => {
  const { t } = useTranslate();
  const hasMandatoryFilters =
    dataset?.filterFirst?.mandatory &&
    dataset?.filterFirst.mandatory.length !== 0;

  return (
    <div className="header">
      <h1>{caption}</h1>
      <Button
        onClick={onSubmitFilters}
        disabled={selectedFilters.length === 0}
        fill="clear"
        color="success"
      >
        <IonIcon icon={checkmarkCircleOutline} slot="start" />
        {t('filterApply')}
      </Button>
      {!hasMandatoryFilters && (
        <Button
          onClick={onResetFilters}
          disabled={hasMandatoryFilters}
          fill="clear"
          color="danger"
        >
          <IonIcon icon={closeCircleOutline} slot="start" />
          {t('cancelFilterAndClose')}
        </Button>
      )}
    </div>
  );
};

export default FilterHeader;
